/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * CampaignInfo reducer
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    CAMPAIGN_INFO_ACTIVATE_SUCCESS,
    CAMPAIGN_INFO_INIT_FAILURE,
    CAMPAIGN_INFO_INIT_START,
    CAMPAIGN_INFO_INIT_SUCCESS,
    campaignInfoInitialState,
} from './campaignInfoConstant';
import { TPageCampaignInfoActions } from './types/campaignInfoActionTypes';
import { ECampaignInfoActions, ICampaignInfoActivateResult, ICampaignInfoGeneral } from './types/campaignInfoTypes';

export interface ICampaignInfoReducer {
    actions: ECampaignInfoActions[];
    activateResult: ICampaignInfoActivateResult;
    info: ICampaignInfoGeneral;
    isError: boolean;
    isLoading: boolean;
    maxParticipantsForActivation?: number;
}

const campaignInfoReducer: Reducer<ICampaignInfoReducer, TPageCampaignInfoActions> =
    (state = campaignInfoInitialState, action: TPageCampaignInfoActions) =>
        produce(state, draft => {
            switch (action.type) {

                // INIT PAGE
                case CAMPAIGN_INFO_INIT_START:
                    draft.isError = false;
                    draft.isLoading = true;
                    break;
                case CAMPAIGN_INFO_INIT_SUCCESS:
                    const { actions, maxParticipantsForActivation, ...info } = action.payload;

                    draft.isLoading = false;
                    draft.actions = actions;
                    draft.info = info;
                    draft.maxParticipantsForActivation = maxParticipantsForActivation;
                    break;
                case CAMPAIGN_INFO_INIT_FAILURE:
                    draft.isLoading = false;
                    draft.isError = true;
                    break;

                // MODAL APPLY & REMOVE
                case CAMPAIGN_INFO_ACTIVATE_SUCCESS:
                    draft.activateResult = action.payload;
                    break;
            }
        });

export default campaignInfoReducer;
